import React, { useState, useEffect } from 'react'
import { useAuth } from '../contexts/AuthContext'

export default function MFAVerification({ mfaResolver, onSuccess, onCancel }) {
  const { resolveMFAChallenge } = useAuth()
  const [verificationCode, setVerificationCode] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')

  useEffect(() => {
    // Extract phone number hint from resolver
    if (mfaResolver?.hints?.[0]?.phoneNumber) {
      const phone = mfaResolver.hints[0].phoneNumber
      // Mask the phone number for display
      const maskedPhone = phone.replace(/(\+\d{1,3})\d{6,10}(\d{4})/, '$1******$2')
      setPhoneNumber(maskedPhone)
    }
  }, [mfaResolver])

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    setError('')

    try {
      await resolveMFAChallenge(mfaResolver, verificationCode, phoneNumber)
      onSuccess && onSuccess()
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              <i className="fas fa-shield-alt me-2"></i>
              Multi-Factor Authentication Required
            </h5>
          </div>
          <div className="modal-body">
            {error && (
              <div className="alert alert-danger">
                <i className="fas fa-exclamation-triangle me-2"></i>
                {error}
              </div>
            )}

            <div className="alert alert-info">
              <i className="fas fa-info-circle me-2"></i>
              A verification code has been sent to {phoneNumber || 'your registered phone number'}
            </div>

            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label">Verification Code</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="123456"
                  value={verificationCode}
                  onChange={(e) => setVerificationCode(e.target.value)}
                  required
                  disabled={loading}
                  maxLength="6"
                  autoComplete="one-time-code"
                />
                <div className="form-text">
                  Enter the 6-digit code sent to your phone
                </div>
              </div>
              <div className="d-flex justify-content-between">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={onCancel}
                  disabled={loading}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={loading || !verificationCode}
                >
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2"></span>
                      Verifying...
                    </>
                  ) : (
                    <>
                      <i className="fas fa-check me-2"></i>
                      Verify Code
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}